import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = '' }) => (
  <span className={`block overflow-hidden pb-[0.14em] -mb-[0.14em] ${className}`}>
    <motion.span
      className="block"
      initial={{ y: '110%' }}
      animate={{ y: '0%' }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ chapter, label, title, align = 'left' }) => (
  <Reveal className={align === 'center' ? 'text-center' : ''}>
    <p className="caption-label mb-4" data-testid={`chapter-${chapter}`}>
      Chapter {chapter} — {label}
    </p>
    <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight text-cream leading-tight">
      {title}
    </h2>
  </Reveal>
);
